import React, { useState, useContext } from "react";
import Dropdown from "./Dropdown";
import AuthContext from "../context/AuthContext";

const DataSplit = ({ procdata }) => {
  const { authTokens } = useContext(AuthContext);
  const inittarget = "col";
  const [targetcol, SetTargetCols] = useState(inittarget);
  const [testprob, setTestProb] = useState();

  // console.log("Proc data:", procdata);

  let traintestdata = async () => {
    let response = await fetch(`${process.env.REACT_APP_URL}/traintestsplit/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + String(authTokens.access),
      },
      body: JSON.stringify({ targetcol,testprob }),
    });

    let data = await response.json();
    if (response.status === 200) {
      if(data['Status'] === 'Done'){
        alert(data['Msg']);
      }
      else{
        alert(data['Error']);
      }
    }
  };

  return (
    <div>
      <div className="my-5">
        <div className="d-flex mb-5">
          <h5>Select Target Columns:</h5>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <Dropdown
            options={procdata}
            id="targetco"
            selectedValue={targetcol}
            onSelectedValueChange={SetTargetCols}
          />
        </div>

        <div className="d-flex my-5">
          <h5>Select Test Data probability:</h5>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <input type="number" name="test_proba" step="any" onChange={(e)=>setTestProb(e.target.value)}></input>
        </div>

        <button className="btn btn-success" onClick={traintestdata}>Proceed</button>
      </div>
    </div>
  );
};

export default DataSplit;
